import { Box, Paper, Typography, Button } from "@mui/material";
import React from "react";
import {TapIcon} from "./TapIcon";
import { AppVersion } from "../types/enums";
import { AppConfig } from "../config/AppConfig";

interface ArViewUIProps {
    isVisible: boolean;
    onBackToMenu: () => void;
}

export const ArViewUI: React.FC<ArViewUIProps> = ({ isVisible, onBackToMenu }) => {
    if (!isVisible) return null;

    const version = AppConfig.version;

    return (
        <>
            <Button
                onClick={onBackToMenu}
                variant="outlined"
                sx={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    zIndex: 1000,
                    color: 'white',
                    fontWeight: 'bold',
                    // fontSize: '1.2rem',
                    // padding: '10px 30px',
                    fontSize: { xs: 'calc(1.0vsh + 1.7vw)', sm: 'calc(1.0vh + 2.0vw)', md: 'calc(1vh + 1.8vw)' },
                    marginTop: { xs: 'calc(1.0vsh + 1.7vw)', sm: 'calc(1.0vh + 2.0vw)', md: 'calc(1vh + 1.4vw)' },
                    borderRadius: '50px',
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'background-color 0.3s ease',
                    border: '2px solid white',
                    background: 'transparent',
                    textTransform: 'none',
                    fontStyle: 'italic',
                    width: 'calc(10vh + 10vw)',
                    pointerEvents: 'auto',
                    '&:hover': {
                        border: '2px solid white',
                        background: 'rgba(255, 255, 255, 0.1)',
                    },
                }}
            >
                Back to Menu
            </Button>
            <Box
                id="point-at-target-marker"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "85%",
                    pointerEvents: "none",
                    zIndex: 10,
                }}
            >
                <Box
                    style={{
                        position: "relative",
                        width: "70%",
                        aspectRatio: "1",
                        maxWidth: "50vh",
                        maxHeight: "60vh",
                        pointerEvents: "none",
                    }}
                >
                    <CornerLine position="topLeft" />
                    <CornerLine position="topRight" />
                    <CornerLine position="bottomLeft" />
                    <CornerLine position="bottomRight" />

                    {/* Scanning Line */}
                    <div
                        style={{
                            position: "absolute",
                            width: "96.5%",
                            height: "9px",
                            backgroundColor: "white",
                            animation: "scan 2s ease-in-out infinite",
                        }}
                    />
                </Box>

                {version === AppVersion.DSM ? (
                    <Typography
                        id="point-at-target-instruction"
                        variant="h6"
                        style={{
                            position: "absolute",
                            top: "80svh",
                            left: "50%",
                            transform: "translateX(-50%)",
                            textAlign: "center",
                            color: AppConfig.theme[version].fontColor,
                            fontWeight: 100,
                            fontStyle: "italic",
                            fontSize: "calc(2.5vh + 1vw)",
                            lineHeight: "calc(2.5vh + 1.2vw)",
                            maxWidth: "50%",
                        }}
                    >
                        Scan over the graphic icon to continue
                    </Typography>
                ) : (
                    <Paper
                        id="point-at-target-instruction"
                        elevation={3}
                        style={{
                            position: "absolute",
                            top: "74svh",
                            padding: "1rem",
                            backgroundColor: "#f0f0f0",
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            width: "38svh",
                            height: "9svh",
                            zIndex: 10,
                        }}
                    >
                        <TapIcon />
                        <Typography
                            variant="h6"
                            style={{
                                textAlign: "center",
                                color: "#333",
                                fontWeight: 100,
                                fontSize: "calc(2vh + 0.7vw)",
                                lineHeight: "calc(2vh + 1vw)",
                            }}
                        >
                            Point the camera at the <strong>target</strong>
                        </Typography>
                    </Paper>
                )}
            </Box>
        </>
    );
};

const CornerLine: React.FC<{ position: string }> = ({ position }) => {
    const baseStyle: React.CSSProperties = {
        position: "absolute",
        width: "50px",
        height: "50px",
        borderTop: "9px solid white",
        borderLeft: "9px solid white",
    };

    const positionStyles: Record<string, React.CSSProperties> = {
        topLeft: { top: 0, left: 0 },
        topRight: { top: 0, right: 0, borderLeft: "none", borderRight: "9px solid white" },
        bottomLeft: { bottom: 0, left: 0, borderTop: "none", borderBottom: "9px solid white" },
        bottomRight: {
            bottom: 0,
            right: 0,
            borderTop: "none",
            borderLeft: "none",
            borderRight: "9px solid white",
            borderBottom: "9px solid white",
        },
    };

    return <div style={{ ...baseStyle, ...positionStyles[position] }} />;
};